import React from "react";

export const PlaceholderLoading = () => (
  <div className="placeholder">
    <div className="animated-background"></div>
  </div>
);
